export default "__VITE_ASSET__CJlGT1s9__"